import { RootPaths } from "@src/appV2/App/paths";

export const LIMITED_ACCESS_INFO_PATH = "limited-access";
export const LIMITED_ACCESS_INFO_FULL_PATH = `${RootPaths.APP_V2_HOME}/${LIMITED_ACCESS_INFO_PATH}`;
